import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';
import { loadPostHog, loadGoogleAnalytics } from '../utils/analytics';

const STORAGE_KEY = 'bestcars_cookie_consent';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    try {
      const accepted = localStorage.getItem(STORAGE_KEY) === 'accepted';
      setIsVisible(!accepted);
      if (accepted) {
        loadPostHog();
        loadGoogleAnalytics();
      }
    } catch {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, 'accepted');
      loadPostHog();
      loadGoogleAnalytics();
    } catch {
      // If storage is unavailable, still dismiss for the current session.
    }
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
        <div
          className="fixed bottom-4 left-4 right-4 z-[60] mx-auto max-w-4xl rounded-2xl border border-white/10 bg-[#0a0a0a]/95 p-4 shadow-2xl shadow-black/50 backdrop-blur-xl transition-transform duration-300 sm:p-5"
          role="dialog"
          aria-live="polite"
          aria-label="Aviso de cookies"
        >
          <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
            <div className="flex gap-3">
              <div className="mt-0.5 flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full border border-[#C41E3A]/25 bg-[#C41E3A]/10 text-[#C41E3A]">
                <Cookie size={20} aria-hidden="true" />
              </div>
              <div>
                <p className="text-sm font-semibold text-white">Utilizamos cookies</p>
                <p className="mt-1 text-sm leading-relaxed text-white/60">
                  Usamos cookies para melhorar a sua experiência no website BestCars. Pode consultar mais detalhes na{' '}
                  <Link to="/politica-cookies" className="font-medium text-white underline decoration-[#C41E3A] underline-offset-4 hover:text-[#C41E3A]">
                    Política de Cookies
                  </Link>
                  .
                </p>
              </div>
            </div>
            <button
              type="button"
              onClick={handleAccept}
              className="inline-flex min-h-11 items-center justify-center rounded-full bg-[#C41E3A] px-6 text-sm font-semibold text-white shadow-lg shadow-[#C41E3A]/25 transition-all duration-300 hover:bg-[#a01830] hover:shadow-[#C41E3A]/35 focus:outline-none focus:ring-2 focus:ring-[#C41E3A] focus:ring-offset-2 focus:ring-offset-[#0a0a0a] md:flex-shrink-0"
            >
              Aceitar
            </button>
          </div>
        </div>
  );
};

export default CookieConsent;
